import { createContext } from "react";
import StepWizard from "react-step-wizard";

export const WizardContext = createContext();

export const CustomStepWizard = ({ contextValue, isLazyMount = false, children, stepHeaders }) => {

    const WizardNav = ({ currentStep, totalSteps }) => {
        // console.log({ currentStep, totalSteps })
        return (
            <div className="row">
                <div className="steps clearfix">
                    <ul role="tablist">

                        {
                            stepHeaders?.map((stepHeader, index) => (
                                <li key={index} role="tab" className={currentStep === (index + 1) ? "current" : "disabled"}>
                                    <span>
                                        <div className="title">
                                            {/* <span className="number current">
                                                {index + 1}
                                            </span> */}
                                            <span className={currentStep === (index + 1) ? "title_text current" : "title_text"}>
                                                {stepHeader}
                                            </span>
                                        </div>
                                    </span>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        )
    }

    return (
        <WizardContext.Provider value={contextValue}>
            <StepWizard transitions="none" isLazyMount={isLazyMount} nav={<WizardNav headers={stepHeaders} />} >
                {children}
            </StepWizard>
        </WizardContext.Provider>
    );

}